import axios from 'axios'
import FileSaver from 'file-saver'
import { getToken, HEADER_PREFIX } from 'utils/auth'
import { getSentryHeaders } from 'utils/sentry'
export const ApiBase = `${process.env.REACT_APP_API_URL}/v1`

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_FILE_SERVER_ADDRESS || 'http://localhost:3006',
})

axiosInstance.interceptors.request.use(async (config) => {
  return {
    ...config,
    headers: {
      ...config.headers,
      ...getSentryHeaders(),
    },
  }
})

export const downloadResponseFile = async (
  responseId,
  params = {},
  config = {}
) => {
  const token = await getToken()
  return axiosInstance
    .get(`/responses/${responseId}`, {
      params,
      responseType: 'blob',
      headers: {
        Authorization: config.useFakeToken
          ? 'Token fake-token'
          : `${HEADER_PREFIX} ${token}`,
      },
    })
    .then((response) => {
      const disposition = response.headers['content-disposition']
      const filename = disposition.split('filename=')[1]
      FileSaver.saveAs(response.data, decodeURIComponent(filename))

      axios.post(
        `${ApiBase}/response/${responseId}/downloaded`,
        {},
        {
          headers: {
            Authorization: config.useFakeToken
              ? 'Token fake-token'
              : `${HEADER_PREFIX} ${token}`,
          },
        }
      )
    })
    .catch((error) => error)
}

export const downloadPacketResponseFile = async (
  packetResponseId,
  params = {},
  config = {}
) => {
  const token = await getToken()
  return axiosInstance
    .get(`/packet-responses/${packetResponseId}`, {
      params,
      responseType: 'blob',
      headers: {
        Authorization: config.useFakeToken
          ? 'Token fake-token'
          : `${HEADER_PREFIX} ${token}`,
      },
    })
    .then((response) => {
      const disposition = response.headers['content-disposition']
      const filename = disposition.split('filename=')[1]
      FileSaver.saveAs(response.data, decodeURIComponent(filename))

      axios.post(
        `${ApiBase}/packet_responses/${packetResponseId}/downloaded`,
        {},
        {
          headers: {
            Authorization: config.useFakeToken
              ? 'Token fake-token'
              : `${HEADER_PREFIX} ${token}`,
          },
        }
      )
    })
    .catch((error) => error)
}

export const downloadFormFile = async (formId, params = {}) =>
  axiosInstance
    .get(`/forms/${formId}`, {
      params,
      responseType: 'blob',
      headers: {
        Authorization: `${HEADER_PREFIX} ${await getToken()}`,
      },
    })
    .then((response) => {
      const disposition = response.headers['content-disposition']
      const filename = disposition.split('filename=')[1]
      FileSaver.saveAs(response.data, decodeURIComponent(filename))
    })
    .catch((error) => error)
